module.exports = __webpack_public_path__ + "img/chicken.e4ce6507.png";